module.exports = (__webpack_require__(0))(388);


//////////////////
// WEBPACK FOOTER
// delegated ./src/templates/widgets/jsonMetadatumEditWidget.pug from dll-reference girder_lib
// module id = 220
// module chunks = 0